'use strict';
var Cookies = require('js-cookie');

var root = 'undefined' === typeof window ? global : window;
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,
    initialize: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },
    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem('dibsy', '');
            this._storage.removeItem('dibsy');
            return true;
        } catch (e) {
            return false;
        }
    },
    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },
    getItems: function () {
        if (!this._supported) {
            return 'localStorage is not supported';
        }
        return this._storage;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            Cookies.set(key, value, {path: '/'});
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            value = Cookies.get(key);
            if (!value && this.data[key]) {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            Cookies.remove(key, {path: '/'});
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();
initializedSessionStorage = SessionStorage.initialize(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.initialize(),
    sessionStorage: initializedSessionStorage
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-browser-storage/index.js
// module id = 282
// module chunks = 64